<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
  >
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <span>{{ $t('dialogs.subscriptionContact.title') }}</span>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="scrollable pt-4">
        <p>{{ $t('dialogs.subscriptionContact.message') }}</p>
        <a href="mailto:accounts@tubeway.io">accounts@tubeway.io</a>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="dialog = false">
          {{ $t('common.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js'

export default {
  name: 'SubscriptionContactDialog',
  mixins: [DialogActionKeys],
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
}
</script>